import { authFetchGET, authFetchPOST, authFetchPUT } from "../utils/auth-fetch";

const env = (<any>window)["appenv"].services.filterapi;

export class UserConfigService {

    static async getSavedFilter(user:string): Promise<any> {
        try {
            let filters;
            let response =  await (authFetchGET(env.scope, `${env.baseurl}/savedfilters/${user}`))
            if(response.length) {
                filters = JSON.parse(response[0]?.data)
            }
            return response;

        }
        catch(e){
            let data:any[] = [];
            return data
        }
    }

    static async upsertFilter(payload: any): Promise<any> {
        try {
            return await (authFetchPOST(env.scope, `${env.baseurl}/upsertfilters`,payload))
        }
        catch(e){
            return ""
        }
    }

    static async getUserMapView(user:string): Promise<any> {
        try {

            let response =  await (authFetchGET(env.scope, `${env.baseurl}/getusersettings?userId=${user}&type=map`))
            let data =  response.data;
            
            // Return the map view if it exists, otherwise default as simplified view
            return data?.value || "simplified";
        }
        catch(e){
            return "simplified";
        }
    }

    static async getUserWeatherView(user:string): Promise<any> {
        try {

            let response =  await (authFetchGET(env.scope, `${env.baseurl}/getusersettings?userId=${user}&type=weather`))
            return response?.data;

        }
        catch(e){
            return "";
        }
    }

    static async upsertUserMapView(payload: any): Promise<any> {
        try {
            return await (authFetchPOST(env.scope, `${env.baseurl}/upsertusersettings`,payload))
        }
        catch(e){
            return "Unable to update user preference";
        }
    }
}
